import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

function HomePage(){
    const dashboard = false
    return (
        <div className='w-full p-3'>
            {!dashboard ? 
                <>
                    <div className='flex w-full'>
                        <p className='text-lg text-slate-300 w-full text-center'>Comming Soon!</p>
                    </div>
                </>
                :
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid xs={3} md={3}>
                        <Item>
                            <div>
                                <div className='text-15'>Total Customers</div>
                                <div className='text-15'>100</div>
                            </div>
                        </Item>
                    </Grid>
                    <Grid xs={3} md={3}>
                        <Item>xs=6 md=4</Item>
                    </Grid>
                    <Grid xs={3} md={3}>
                        <Item>xs=6 md=4</Item>
                    </Grid>
                    <Grid xs={3} md={3}>
                        <Item>xs=6 md=8</Item>
                    </Grid>
                </Grid>
            </Box>
            }
    </div>
    )
}

export default HomePage